const sortByProperty = (
  arr: any[],
  propertyName: string,
  secondPropertyName?: string | undefined,
) => {
  return arr.sort((a, b) => {
    // Convert the property values to lowercase for case-insensitive sorting
    let x = getValue(a, propertyName);
    let y = getValue(b, propertyName);

    if (secondPropertyName) {
      const x1 = getValue(a, secondPropertyName);
      const y1 = getValue(b, secondPropertyName);
      x = `${x} ${x1}`.toLowerCase();
      y = `${y} ${y1}`.toLowerCase();
    }

    const exp1 = x > y ? 1 : 0;
    return x < y ? -1 : exp1;
  });
};

const getValue = (obj: any, propertyName: string) => {
  return Object.prototype.hasOwnProperty.call(obj, propertyName) &&
    obj[propertyName] &&
    obj[propertyName].length > 0
    ? obj[propertyName].toLowerCase()
    : 'zzz';
};

export { sortByProperty };
